<template>
    <vue-google-map :class="cssClass" :center="center" :zoom="zoom">
        <vue-google-marker :position="center" :clickable="false" :draggable="false"></vue-google-marker>
    </vue-google-map>
</template>

<script>
    export default {
        props: {
            cssClass: {
                type: String,
            },
            zoom: {
                type: Number,
                default: 18,
            },
            latitude: {
                type: Number,
                required: true,
            },
            longitude: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                center: {
                    lat: this.latitude,
                    lng: this.longitude,
                },
            };
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/GoogleMap.vue